import React, { useEffect, useState } from 'react'
import { Button, Container } from 'react-bootstrap'
import './style.css'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import FloatingButtonWrapper from 'components/FloatingButtonWrapper'
import AwaitingLabellingTaskList from 'features/AwaitingLabelling/AwaitingLabellingTaskList'
import AwaitingLabellingArticleList from 'features/AwaitingLabelling/AwaitingLabellingArticleList'
import Printing from 'features/Printing/Printing'
import { toggleShowPrinting } from 'features/Printing/duck'
import FloatingNumpad from 'components/FloatingNumpad'
import LoadingSpinner from 'components/LoadingSpinner'
import usePrinters from 'lib/hooks/usePrinters'

import {
	useLazyFetchAwaitingLabellingQuery
} from 'api/pickingApi'

const AwaitingLabelling = () => {
	const navigate = useNavigate()
	const dispatch = useDispatch()

	const [triggerFetchAwaitingLabelling, { data: awaitingLabelling, isFetching: isAwaitingLabellingLoading }] = useLazyFetchAwaitingLabellingQuery()
	const [items, setItems] = React.useState([])

	const [onSelectPrintCount, setOnSelectPrintCount] = useState(false)
	const [labelCount, setLabelCount] = useState('1')
	const [ordersToPrint, setOrdersToPrint] = useState([])
	const { printPalletLabel } = usePrinters()

	const handleGoHome = () => {
		navigate('/')
	}

	const onSelectTask = (task) => {
		setItems(task.rows || [])
	}

	const goBackToTasks = () => {
		setItems([])
	}

	const onSelectPrint = (task) => {
		setOnSelectPrintCount(true)
		setOrdersToPrint(task.orderIds || [])
	}

	const onNumpadChange = (value) => {
		const newValue = value === '' ? '' : Math.max(1, Math.min(99, Number.parseInt(value))).toString()
		setLabelCount(newValue)
	}

	const togglePrint = () => {
		setOnSelectPrintCount(false)
		dispatch(toggleShowPrinting())
	}

	const onConfirmNumpad = () => {
		togglePrint()
	}

	const onClearNumpad = () => {
		setLabelCount('')
	}

	const onPrintPicking = (printer) => {
		printPalletLabel(printer, ordersToPrint, Number(labelCount))
	}


	const showPrinting = useSelector((state) => state.printing.showPrinting)

	useEffect(() => {
		triggerFetchAwaitingLabelling()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	const isArticleView = items && items.length > 0
	const isLoading = isAwaitingLabellingLoading
	const loadingSpinner = isLoading ? <LoadingSpinner /> : ''
	return (
		<>
			<Container className="picking">
				{loadingSpinner}
				{isArticleView ? (
					<AwaitingLabellingArticleList items={items} />
				) : (
					<AwaitingLabellingTaskList awaitingLabelling={awaitingLabelling} onSelectTask={onSelectTask} onSelectPrint={onSelectPrint} />
				)}
			</Container>
			{onSelectPrintCount && (
				<FloatingNumpad
					headerText={'Enter number of labels to print'}
					closeOutSide={true}
					text={String(labelCount)}
					onChange={onNumpadChange}
					onSend={onConfirmNumpad}
					hideExtraButton={true}
					onClear={onClearNumpad}
					showStockButton={false}
				/>

			)}
			{showPrinting && <Printing onPrint={onPrintPicking} />}
			<FloatingButtonWrapper>
				<Button variant="danger" size="lg" onClick={handleGoHome}>
					Home
				</Button>
				{isArticleView && (
					<Button variant="secondary" size="lg" onClick={() => goBackToTasks()}>
						Back to Tasks
					</Button>
				)}
			</FloatingButtonWrapper>
		</>

	)
}

export default AwaitingLabelling
